export default __webpack_public_path__ + "static/media/Poppins-Light.7641a0f7.woff";